<template>
    <div>
        <v-card flat color="lightgray">
            <v-card-text class="text-h6 font-weight-bold pb-0">
                {{userData.name}}
            </v-card-text>
        </v-card>

        <!-- salary-sheet is declared here to use it as ref -->
        <salary-sheet v-if="0" ref="SalarySheet" :salary="salary"/>

        <!-- salary-sheet is declared here to use it as ref -->
        <vication-sheet ref="VicationSheet"/>

        <!-- administrative-sheet is declared here to use it as ref -->
        <administrative-sheet ref="AdministrativeSheet"/>

        <loader v-if="loading"/>

        <v-container v-else>
			<!-- current balance -->
            <template v-if="usePrices">
				<div class="d-flex flex-column align-center">
					<div class="text-body-1 font-weight-bold mb-0">{{$T('current-balance')}}</div>
					<span class="text-h5 font-weight-bold primary--text">{{$options.filters.formatNumber(balance || 0, 3)}}</span>
				</div>
				<v-divider class="mt-2 mb-4 mx-auto" inset/>
			</template>

            <!-- buttons -->
            <v-row justify="center" class="mb-5">
                <!-- Administrative button -->
                <v-col cols="3" class="d-inline-flex flex-column align-center" >
					<v-btn
						fab
						color="primary"
						@click="$refs.AdministrativeSheet.activeSheet"
					>
                        <v-icon size="1.9rem">mdi-clipboard-text-outline</v-icon>
                    </v-btn>
                    <span class="mt-3 text-subtitle-2">{{$T('administrative')}}</span>
                </v-col>

                <!-- Leaves button -->
                <v-col cols="4" class="d-inline-flex flex-column align-center">
					<v-btn
						fab
						color="primary"
						@click="$refs.VicationSheet.activeSheet"
					>
                        <v-icon size="1.9rem">mdi-airplane</v-icon>
                    </v-btn>
                    <span class="mt-3 text-subtitle-2">{{$T('leaves')}}</span>
                </v-col>

                <!-- Salary botton -->
                <v-col v-if="0" cols="3" class="d-inline-flex flex-column align-center">
                    <v-btn
                      fab
                      @click="$refs.SalarySheet.activeSheet"
                      color="primary"
                    >
                        <v-icon size="1.9rem">mdi-currency-usd</v-icon>
                    </v-btn>
                    <span class="mt-3 text-subtitle-2">{{$T('salary')}}</span>
                </v-col>
            </v-row>

            <!-- visits -->
            <v-card outlined class="mb-5">
                <v-card-title class="text-body-2">
                    <v-icon color="secondary" class="me-2">mdi-briefcase-check-outline</v-icon>
                    <span>{{$T('visits')}}</span>
                </v-card-title>

                <v-card-text>
                    <span class="text-subtitle-2 font-weight-bold">{{$T('today-visits')}}</span>
                    <v-progress-linear
                      color="primary"
                      class="mt-3 mb-1"
                      background-color="grey lighten-2"
                      rounded
                      height="10"
                      :value="(target.visitsToday / (target.value || 10)) * 100"
                    />
                    <span>
						{{
							$T('you-have-completed-$-out-of-$', {
								num1: target.visitsToday || 0,
								num2: $options.filters.formatNumber(target.value, 3) || 10
							})
						}}
                    </span>
                </v-card-text>
            </v-card>

            <!-- financial target -->
            <template v-if="shouldShowFinancialTarget">
                <v-card outlined class="mb-5">
                    <v-card-title class="text-body-2">
                        <v-icon color="secondary" class="me-2">mdi-cash</v-icon>
                        <span>{{$T('financial-target')}}</span>
                    </v-card-title>

                    <v-card-text>
                        <span class="text-subtitle-2 font-weight-bold">{{$T('today-income')}}</span>
                        <v-progress-linear
                          color="primary"
                          class="mt-3 mb-1"
                          background-color="grey lighten-2"
                          rounded
                          height="10"
                          :value="(financialTarget.visitsToday / (financialTarget.value || 10)) * 100"
                        />
                        <span>
							{{
								$T('you-have-completed-$-out-of-$', {
									num1: $options.filters.formatNumber(financialTarget.visitsToday, 3) || 0,
									num2: financialTarget.value ? $options.filters.formatNumber(financialTarget.value, 3) : $options.filters.formatNumber(1000, 0)
								})
							}}
                        </span>
                    </v-card-text>
                </v-card>
            </template>

            <v-row>
                <!-- Last Rating -->
                <v-col cols="6">
                    <v-card outlined>
                        <v-card-title class="text-body-2">
                            <v-icon color="secondary" class="me-2">mdi-finance</v-icon>
                            <span>{{$T('last-rating')}}</span>
                        </v-card-title>

                        <v-card-text class="text-center">
                            <v-progress-circular
                              color="primary"
                              size="110"
                              width="8"
                              :value="review.averageMarks ? review.averageMarks.sum : 0"
                              rotate="-90"
                            >
                                <span class="text-h6 grey--text text--darken-2">
                                    {{$options.filters.formatNumber((review.averageMarks ? review.averageMarks.sum : 0), 3) + '%'}}
                                </span>
                            </v-progress-circular>
                            <p class="mt-2 mb-0">
                                {{$T('last-rating')}}: {{review?.reviews?.length > 0 ? review.reviews[0].marks.sum : 0}}
                            </p>
                        </v-card-text>
                    </v-card>
                </v-col>

                <!-- Leaves -->
                <v-col cols="6">
                    <v-card outlined>
                        <v-card-title class="text-body-2">
                            <v-icon color="secondary" class="me-2">mdi-airplane</v-icon>
                            <span>{{$T('leaves')}}</span>
                        </v-card-title>

                        <v-card-text class="text-center">
                            <v-progress-circular
                              color="primary"
                              size="110"
                              width="8"
                              :value="(leaves.remainingNumberOfLeaves / leaves.daysCount) * 100"
                              rotate="-90"
                            >
                                <span class="text-h6 grey--text text--darken-2">
								{{$options.filters.formatNumber(leaves.remainingNumberOfLeaves, 3)}}/{{$options.filters.formatNumber(leaves.daysCount, 3)}}
								</span>
                            </v-progress-circular>

                            <p class="mt-2 mb-0">
								{{$options.filters.formatNumber(leaves.remainingNumberOfLeaves, 3)}} {{$T('leaves-remaining')}}
							</p>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import Loader from '../components/Loader'
import SalarySheet from '../components/SalarySheet'
import VicationSheet from '../components/VicationSheet'
import AdministrativeSheet from '../components/AdministrativeSheet'
import { mapState, mapGetters } from 'vuex'
import { usePrices } from '@/configs/general.configs'

export default {
	name: 'Profile',

	data() {
		return {
			usePrices,

			loading: true,

			snackbar: false,
			message: null,
		}
	},

	computed: {
		...mapState({
			userData: state => state.auth.userData,
			self: state => state.auth.self,
			balance: state => state.profile.balance,
			target: state => state.profile.target,
			financialTarget: state => state.profile.financialTarget,
			salary: state => state.profile.salary,
			leaves: state => state.profile.leaves,
			review: state => state.profile.review,
			vacations: state => state.vacations.vacations,
		}),
		...mapGetters({
			repType: 'auth/repType',
		}),
		shouldShowFinancialTarget() {
			return (this.repType === 'Financial' || this.repType === 'Both')
		}
	},

	components: {
		Loader,
		SalarySheet,
		VicationSheet,
		AdministrativeSheet
	},

	mounted() {
		Promise.all([
			usePrices && !this.balance
				? this.$store.dispatch('profile/fetchBalance')
				: null,
			this.$store.dispatch('profile/target'),
			this.shouldShowFinancialTarget ? this.$store.dispatch('profile/financialTarget') : null,
			this.$store.dispatch('profile/salary'),
			this.$store.dispatch('profile/leaves', { employeeId: this.self.employeeId }),
			this.$store.dispatch('profile/review'),
			!this.vacations.length ? this.$store.dispatch('vacations/fetchAll') : null
		]).finally(() => {
			this.loading = false;
		})
	},

	beforeDestroy() {
		this.$store.dispatch('profile/reset');
	}
}
</script>

<style>

</style>